<app-wizard-step-wrapper
  [showStep]="showStep"
  [stepTitle]="stepMetadata.stepName"
  [formGroup]="formStep"
  >
  <div class="form-step__subheading">
    We need a few pieces of information to verify your identity
  </div>

  <app-alert-banner [type]="'information'" [message]="'Please ensure the information you are providing is error-free before leaving this page.'">
  </app-alert-banner>

  @if (signerDetailsStatus) {
    <div class="form-section">
      <h3>Signer Details</h3>
      <div class="form-row">
        <div class="form-column" [ngClass]="{ 'no-error': !signerDetailsStatus.isMissingFirstName }">
          <app-text-input
            data-private
            [autocomplete]="'given-name'"
            [dataTestId]="'first-name'"
            [errorMessage]="errors.firstName"
            [formControlRef]="firstName"
            [label]="'First Name'"
            [maxLength]="128"
            [placeholder]="'First Name'"
          ></app-text-input>
        </div>
        <div class="form-column" [ngClass]="{ 'no-error': !signerDetailsStatus.isMissingLastName }">
          <app-text-input
            data-private
            [autocomplete]="'family-name'"
            [dataTestId]="'last-name'"
            [errorMessage]="errors.lastName"
            [formControlRef]="lastName"
            [label]="'Last Name'"
            [maxLength]="128"
            [placeholder]="'Last Name'"
          ></app-text-input>
        </div>
      </div>
      @if (signerDetailsStatus.isMissingSignatureName) {
        <div class="form-row">
          <app-text-input
            data-private
            [dataTestId]="'signature-name'"
            [formControlRef]="signatureName"
            [isFullWidth]="true"
            [label]="'The name to use for your signature'"
            [maxLength]="256"
            [placeholder]="'Example: John Smith'"
        [tooltipText]="
          'This is the name that will be used to create your signature and will be shown when you sign a document.'
        "
          ></app-text-input>
        </div>
      }
      <div class="form-row">
        @if (signerDetailsStatus && signerDetailsStatus.isMissingEmail) {
          <div class="form-column">
            <app-text-input
              data-private
              [autocomplete]="'email'"
              [dataTestId]="'email-address'"
              [errorMessage]="errors.emailAddress"
              [formControlRef]="emailAddress"
              [inputmode]="'email'"
              [label]="'Email Address'"
              [maxLength]="128"
              [placeholder]="'youremail@domain.com'"
            ></app-text-input>
          </div>
        }
        @if (signerDetailsStatus && signerDetailsStatus.isMissingPhoneNumber) {
          <div
            class="form-column"
            >
            <app-phone-input
              data-private
              [dataTestId]="'phone-number'"
              [errorMessage]="errors.phoneNumber"
              [formControlRef]="phoneNumber"
              [label]="'Phone Number'"
            ></app-phone-input>
          </div>
        }
      </div>
      <div class="form-row">
        @if (signerDetailsStatus && signerDetailsStatus.isMissingDateOfBirth) {
          <div
            class="form-column"
            >
            <div>
              <h4>What is your date of birth?</h4>
              <app-text-input
                data-private
                [autocomplete]="'bday'"
                [dataTestId]="'birth-date'"
                [errorMessage]="errors.dateOfBirth"
                [formControlRef]="dateOfBirth"
                [label]="'Date of birth'"
                [mask]="'00/00/0000'"
                [placeholder]="'MM/DD/YYYY'"
              ></app-text-input>
            </div>
          </div>
        }
        @if (signerDetailsStatus && signerDetailsStatus.isMissingSsn) {
          <div class="form-column">
            <div>
              <h4>What is the last 4 of your SSN?</h4>
              <app-password-input
                data-private
                [dataTestId]="'ssn'"
                [errorMessage]="errors.ssn"
                [formControlRef]="ssn"
                [inputmode]="'numeric'"
                [label]="'Last 4 of SSN'"
              ></app-password-input>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (signerDetailsStatus && signerDetailsStatus.isMissingAddress) {
    <div class="form-section">
      @if (signerDetailsStatus && signerDetailsStatus.isMissingAddress) {
        <h3>Current Address</h3>
      }
      <div class="form-row">
        <app-text-input
          data-private
          [autocomplete]="'address-line1'"
          [dataTestId]="'street-address'"
          [errorMessage]="errors.address1"
          [formControlRef]="address1"
          [isFullWidth]="true"
          [label]="'Street Address'"
          [maxLength]="100"
          [placeholder]="'Street Address'"
        ></app-text-input>
      </div>
      <div class="form-row">
        <app-text-input
          data-private
          [autocomplete]="'address-line2'"
          [dataTestId]="'street-address-2'"
          [errorMessage]="errors.address2"
          [formControlRef]="address2"
          [isFullWidth]="true"
          [label]="'Apt, Suite, etc. \(optional\)'"
          [maxLength]="50"
        ></app-text-input>
      </div>
      <div class="form-row">
        <div class="form-column city-column">
          <app-text-input
            data-private
            [autocomplete]="'address-level2'"
            [dataTestId]="'city-name'"
            [errorMessage]="errors.city"
            [formControlRef]="city"
            [isFullWidth]="true"
            [label]="'City'"
            [maxLength]="50"
            [placeholder]="'City Name'"
          ></app-text-input>
        </div>
        <div class="form-column state-zip-column">
          <div class="form-fields">
            <app-select-input
              data-private
              class="state-input"
              [autocomplete]="'address-level1'"
              [dataTestId]="'state-name'"
              [errorMessage]="errors.state"
              [formControlRef]="state"
              [isFullWidth]="true"
              [label]="'State'"
              [options]="states$ | async"
              [placeholder]="'State'"
            ></app-select-input>
            <app-text-input
              data-private
              class="zip-input"
              [autocomplete]="'postal-code'"
              [dataTestId]="'zip-code'"
              [errorMessage]="errors.zipCode"
              [formControlRef]="zipCode"
              [inputmode]="'numeric'"
              [isFullWidth]="true"
              [label]="'Zip Code'"
              [maxLength]="50"
              [mask]="'00000'"
              [placeholder]="'12345'"
            ></app-text-input>
          </div>
        </div>
      </div>
    </div>
  }

  <app-button-container>
    <app-button
      type="primary"
      (click)="goToNextStep()"
      [dataTestId]="'next-button-additionaldetails'"
      >
      Next
    </app-button>
  </app-button-container>
</app-wizard-step-wrapper>
